import { useContext } from "react";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import { SalesDetail, AppointmentDetail, GroupDetail } from "./EachSalaryDetail";

type Props = {
  salaryType: "SALES" | "APPOINTMENT" | "GROUP";
  seqNewSettlementPayroll: number;
};

const EachSalaryDetailPop = ({ salaryType = "SALES", seqNewSettlementPayroll }: Props) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "EACH_SALARY_DETAIL_POP",
      open: { eachSalaryDetailPop: false },
    });
  };

  const MAPPING = {
    SALES: {
      title: "영업 커미션 상세",
      component: <SalesDetail seqNewSettlementPayroll={seqNewSettlementPayroll} />,
    },
    APPOINTMENT: {
      title: "개인레슨 수당 상세",
      component: <AppointmentDetail seqNewSettlementPayroll={seqNewSettlementPayroll} />,
    },
    GROUP: {
      title: "그룹수업 수당 상세",
      component: <GroupDetail seqNewSettlementPayroll={seqNewSettlementPayroll} />,
    },
  };

  return (
    <CustomDialog open={state.eachSalaryDetailPop} onClose={handleClose}>
      <PopupHeader title={MAPPING[salaryType].title} onClickBack={handleClose} />
      {MAPPING[salaryType].component}
    </CustomDialog>
  );
};

export default EachSalaryDetailPop;
